import { DatePicker } from "antd";
import dayjs from "dayjs";

const VALUE_FORMAT = "YYYY-MM-DD";
const DISPLAY_FORMAT = "MM/DD/YYYY";

interface ReportDatePickerProps {
    value?: string;
    defaultValue?: string;
    placeholder?: string;
    onChange?: (value: string) => void;
}

const parseDate = (value?: string) => value ? dayjs(value, VALUE_FORMAT) : undefined;

export function ReportDatePicker({ value, defaultValue, placeholder = "mm/dd/yyyy", onChange }: ReportDatePickerProps) {
    return (
        <DatePicker
            allowClear
            className="rc-date-picker"
            defaultValue={value ? undefined : parseDate(defaultValue)}
            format={DISPLAY_FORMAT}
            popupClassName="rc-date-picker-popup"
            placeholder={placeholder}
            value={value !== undefined ? parseDate(value) || null : undefined}
            onChange={(date) => onChange?.(date ? date.format(VALUE_FORMAT) : "")}
        />
    );
}
